<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div
      v-for="(invoice, key) in results"
      :key="key"
      class="nopads"
    >
      <InvoicingContractTable
        ref="contractTable"
        :invoice="invoice"
        :invoice-state-options="invoiceStateOptions"
        :user="user"
        @show-order="emitShowOrder"
        @show-trip-order="emitTripOrder"
        @show-contract-details="emitContractDetails"
        @show-trip-details="emitTripDetails"
        @show-invoice-histories="emitInvoiceHistories"
        @show-trip-deliveries="emitTripDeliveries"
        @update-summaries="emitSummaries"
        @accept-invoicing="acceptInvoicing"
      />
      <hr class="report-divider ml-2 mr-2">
    </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import InvoicingContractTable from "@/components/invoice/InvoicingContractTable.vue";
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'InvoicingList',
    components: {InvoicingContractTable},
    mixins: [timeUtils, workManagementHelper],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        invoiceStateOptions: {
            type: Array,
            default() {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        },
        closeAllRows: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        closeAllRows() {
            if(this.closeAllRows) {
                this.collapseAllContractRows()
                this.$emit("setCollapsedStateBack")
            }
        }
    },
    methods: {
        collapseAllContractRows() {
            // Normalize to an array (Vue may return single instance for single item)
            let contracts = this.$refs.contractTable || []
            if (!Array.isArray(contracts)) contracts = [contracts]

            contracts.forEach((contract, idx) => {
                if (!contract) return
                // guard that the method exists
                if (typeof contract.collapseOrderRows === 'function') {
                    // optional stagger:
                    setTimeout(() => contract.collapseOrderRows(), idx * 80)
                }
            })
        },
        acceptInvoicing: function (item) {
            this.$emit('acceptInvoicing', item)
        },
        emitShowOrder(order, contract) {
            this.$emit('showOrder', order, contract)
        },
        emitTripOrder(row) {
            this.$emit('showTripOrder', row)
        },
        emitContractDetails(row) {
            this.$emit('showContractDetails', row)
        },
        emitInvoiceHistories(row) {
            this.$emit('showInvoiceHistories', row)
        },
        emitSummaries() {
            this.$emit('updateSummaries')
        },
        emitTripDetails(row) {
            this.$emit('showTripDetails', row)
        },
        emitTripDeliveries(row) {
            this.$emit('showTripDeliveries', row)
        },
    }
}
</script>
